import { render, staticRenderFns } from "./HealthLink.vue?vue&type=template&id=5339580a"
import script from "./HealthLink.vue?vue&type=script&lang=js"
export * from "./HealthLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports